<div class="row">
    <div class=" col-md-12 d-block pb-0 text-end">
        <button class="button-cls" (click)="closeDialog()">
            <img src="assets/images/arrow_close.svg">
        </button>
    </div>
</div>
<div class="row bg-white m-0 d-flex justify-content-between ">
    <div class="col-md-6 p-0  sideimg">
        <div class="signupback">
            <img src="assets/images/auth.png">
        </div>   
             </div>
    <div class="col-md-6 m-auto reset" [formGroup]="loginForm" >
        <h4 class="mt-md-5 mt-3 px-md-5 px-0">Reset Password</h4>
        <!-- <p class="mt-1 px-md-5 p-0 formabout">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. lorem is Sed laying
        </p> -->
        <!-- login with phone -->
        <div>
            <div class="phonedetail d-grid px-md-5 p-0 mt-md-0 mt-5">
                <label>New Password</label>
                <div class="w-100 position-relative mt-2">
                    <div class="cursor-pointer" (click)="onClick()">
                        <img class="message" *ngIf="!show" src="assets/images/lock@1x.png" alt=""  width="20px" height="20px">
                        <img class="message smsdata1" *ngIf="show" src="assets/images/unlock.png" alt="" width="20px" height="20px">
                    </div>
                    <!-- <img class="" src="assets/images/lock@1x.png" alt="" (click)="hidePassword = !hidePassword"> -->
                    <input [type]="password" class="form-control emaildata ps-3" formControlName="new_password" maxlength="16"
                     placeholder="Enter the new password">
                     <small [class]="loginForm.get('new_password').errors?.pattern?'mt-1':'password-message mt-1'">
                        * Password can contain alphabets,numbers,special characters and must be of 8 characters
                    </small>
                    <div>
                        <small *ngIf="submitted && loginForm.controls['new_password'].invalid" class="alert">
                            <small *ngIf="submitted && loginForm.controls['new_password'].errors.required">
                                Password is required
                            </small>
                            <!-- <small *ngIf="loginForm.get('new_password').errors.pattern">
                                Password must contain at least one number, one uppercase and one special
                                and at least 8 characters
                            </small> -->
                        </small>
                        </div>
                </div>
            </div>
            <div class="phonedetail d-grid mt-4 px-md-5 p-0">
                <label>Confirm New Password</label>
                <div class="w-100 position-relative mt-2">
                    <div class="cursor-pointer" (click)="confirm()">
                        <img class="securepassword" *ngIf="!confirmshow" src="assets/images/lock@1x.png" alt=""  width="20px" height="20px">
                        <img class="securepassword smsdata1" *ngIf="confirmshow" src="assets/images/unlock.png" alt="" width="20px" height="20px">
                    </div>
                    <!-- <img class="securepassword" src="assets/images/lock@1x.png" alt="" (click)="hideConfirmPassword = !hideConfirmPassword"> -->
                    <input [type]="confirmpassword" class="form-control emaildata ps-3" maxlength="16"
                    
                        placeholder="Enter the confirm password" formControlName="confirm_password">
                        <small *ngIf="submitted && loginForm.controls['confirm_password'].invalid " class="alert">
                            <small *ngIf="submitted && loginForm.controls['confirm_password'].errors.required">
                                Confirm password is required
                            </small>
                            <small *ngIf="loginForm.get('confirm_password').errors.confirmPasswordValidator">Passsword
                                and
                                Confirm Password didn't match. </small>
                        </small>
                </div>
            </div>
        </div>
        <!-- <div class="text-center validpassword  mt-4 ">      
              <small class="text-danger my-2" *ngIf="(submitted && loginForm.get('password1').invalid)">
                 <img src="assets/images/info-circle_red.svg" alt="">Password didn’t matched</small>
        </div> -->
        <!-- <div class="text-center validpassword  mt-4 ">
            <small class="text-danger my-2" *ngIf="wrongpassword">
                <img src="assets/images/info-circle_red.svg" alt="">Password didn’t matched</small>
        </div> -->
        <div class="text-center resetbtn">
            <button class="loginbtn cursor-pointer"  (click)="onSubmit(loginForm.value)">Save & Continue</button>
        </div>
      
    </div>
</div>